export default "__VITE_ASSET__d753f21c__"